export default {
    RP_PROPOSALS_REPORT: 'rp.proposals.report',
    NEARMAP: 'nearmap.type',
    PROPERTY_INVESTMENT_REPORT: 'crux-property-investment-report',
    DIGITAL_PROFILE_REPORT: 'crux.digital.profile.report',
    FORMS_INTEGRATION: 'crux-rei-forms',
    NZ_MAP_LAYER_FLOOD: 'pg.flood.layer',
    SEARCH_RESULT_MAP_VIEW: 'search.result.map.view',
    REINZ_MEMBERSHIP: 'crux-reinz-member',
    EQUITY_REPORT: 'crux-equity-calculator-report',
    HISTORIC: 'crux.historic.property.data',
    NATURAL_RISKS: 'crux-natural-risks',
    CAMPAIGN_HISTORY: 'crux.unleash.campaign.history',
    PROPERTY_HUB_LINK: 'property.hub.redirect',
    AVM_HISTORY: 'crux-avm-history',
};
